import { useSuppliers } from 'hooks/useSuppliers/index';
import React, { createContext, useContext } from 'react';

export const SuppliersContext = createContext({} as ReturnType<typeof useSuppliers>);

export const SuppliersProvider = ({ children }: { children: React.ReactNode }) => {
  const config = useSuppliers();
  return <SuppliersContext.Provider value={config}>{children}</SuppliersContext.Provider>;
};

export const useSuppliersContext = () => useContext(SuppliersContext);
